// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__34_0k","noInteraction":"EventWrapper_noInteraction__2REhG","pointerPassthrough":"EventWrapper_pointerPassthrough__xn_ey"};